// redirect to login
export const handleLoginRedirect = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('okta-token-storage');
  window.location.href = '/login';
};
